import Avery from '@averyano/core';

import { Detection } from './classes/Detection';

import NodeEmitter from './classes/NodeEmitter';
import CookieBanner from './components/CookieBanner';

import Navigation from './components/Navigation';
import Preloader from './components/@avery-loader/Preloader';

import Lenis from '@studio-freight/lenis';
import GSAP from 'gsap';
import { debounce, requestIdleCallbackPolyfill } from './utils/utils';
import ScrollTrigger from 'gsap/all';
console.log(FN_URL);
// Pages

import NotFound from './pages/NotFound';
import Footer from './components/Footer';
import HomePage from './pages/Home';
import BioPage from './pages/Bio';
import GalleryPage from './pages/Gallery';

import LazyLoader from './components/@avery-loader/LazyLoader';
import LangPopup from './components/LangPopup';

import each from 'lodash/each';
// import data from '../locales/en.json';
// console.log(data);
import posthog from 'posthog-js';

window.locale = 'en';
class App {
	constructor() {
		this.getCurrentLocale();

		this.isCreated = false;
		this.scrollOnLoad = null;
		this.create();
		this.createContent();
		this.createNavigation();
		this.createPreloader();
		this.registerNodeEvents();
	}

	create() {
		requestIdleCallbackPolyfill();

		// Scroll
		this.scroll = new Lenis({
			// syncTouch: true,
			// easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
		});

		// this.scroll.on('scroll', ScrollTrigger.update);
		// this.scroll.on('scroll', (e) => console.log(e));
		// Canvas

		// Other
		this.addEventListeners();
		this.update();
	}

	createPreloader() {
		this.pageState = {
			previous: null,
			current: null,
		};
		this.avery = new Avery({
			detection: Detection,
			loader: {
				pages: this.pages,
				preloader: this.preloader,
				onLeave: async () => {
					await this.preloader.show();
					this.scroll.destroy();
					this.footer.destroy();

					this.navigation.closeAll();
					this.avery.$emit('hideMenu');
					this.avery.$emit('hideAllPopups');
					this.pageState = {
						previous: null,
						current: null,
					};
					// kill all ScrollTrigger instances
					// ScrollTrigger.getAll().forEach((instance) => instance.kill());
				},
				beforeEnter: () => {
					console.log(`Before Enter ${this.avery.loader.template}`);
					window.scrollTo(0, 0);
					this.pageState.previous = this.avery.loader.template;
					this.preloader.selectorChildren.images =
						this.avery.loader.router.content.images;
					this.preloader.createComponent();
					this.preloader.createLoader(this.avery.loader.template);
				},
				onEnter: () => {
					// GlobalHandler.setTemplate = this.loader.template;
				},

				afterEnter: () => {
					this.scroll.destroy();
					this.scroll = new Lenis();
					console.log(`After Enter ${this.avery.loader.template}`);
					this.pageState.current = this.avery.loader.template;
					if (this.pageState.previous !== this.pageState.current) {
						this.scroll.scrollTo('top');
						window.scrollTo(0, 0);
					}
					this.footer.create();

					// if (this.loader.template === 'home') {
					// 	NodeEmitter.emit('hideMenu');
					// } else {
					// }
				},
				onPreloaded: async () => {
					console.log('CURRENT:', this.avery.loader.current.page);
					this.lazyLoader.init();

					this.getCurrentLocale();
					this.langPopup.setActiveLang();

					document.body.classList.remove('refresh');

					await this.avery.loader.current.page.show();
					this.avery.$emit('showMenu');

					this.navigation.updateNav(this.avery.loader.template);

					// this.footer.show();
					this.preloader.hide();
					this.onResize();

					// if (
					// 	this.avery.loader.template === 'store' ||
					// 	this.avery.loader.template === 'productview'
					// ) {
					// 	each(this.avery.loader.current.page.components, (component) => {
					// 		if (component.createMarq) component.createMarq();
					// 	});
					// }

					console.log(this.avery.loader.template);
					console.log('onPreloaded');
				},
			},
		});
		window.isMobile =
			this.avery.detection.isMobile || this.avery.detection.isTablet;
		// Loader
		this.id = document.querySelector('[data-page]').dataset.page;
		console.log('ID', this.id);
		if (this.id === 'home') {
			this.preloader.createLoader('home');
		}
		if (this.id === 'bio') {
			this.preloader.createLoader('bio');
		}
		if (this.id === 'gallery') {
			this.preloader.createLoader('gallery');
		}
		if (this.id === '404' || !this.id) {
			this.preloader.createLoader('404');
		}

		console.log(this.avery);
		this.avery.start();
		this.avery.$on('scrollTo', (e) => {
			console.log('ScrollTo', e);
			if (this.scroll) this.scroll.scrollTo(e);
			else {
				const target = document.querySelector(e);
				if (target) {
					const top = target.getBoundingClientRect().top + window.pageYOffset;
					window.scrollTo({
						top: top,
						behavior: 'smooth',
					});
				}
			}
		});

		this.avery.$on('scrollOnLoad', (e) => {
			this.scrollOnLoad = e;
		});

		this.avery.$on('hideAllPopups', () => {
			this.langPopup.hide();
		});
	}

	createNavigation() {
		this.navigation = new Navigation();
		this.navigation.show();
	}

	createContent() {
		this.lazyLoader = new LazyLoader();
		this.preloader = new Preloader();
		this.mainDiv = document.querySelector('.main-div');

		// Pages
		this.home = new HomePage('.home');
		this.bio = new BioPage('.bio');
		this.gallery = new GalleryPage('.gallery');
		this.notfound = new NotFound('.notfound');

		// Popups
		this.langPopup = new LangPopup();
		this.langPopup.create();

		// Routing
		this.pages = [
			{ page: this.home, url: ['/', '/home'] },
			{ page: this.bio, url: '/bio' },
			{ page: this.notfound, url: '/404' },
			{ page: this.gallery, url: '/gallery' },
			// { page: this.store, url: '/store' },
			// {
			// 	page: this.productview,
			// 	url: '/store/:id',
			// 	pointer: 'id',
			// 	data: STOREPRODUCTS[window.locale], // [{ id }, { id }, ..., { id }]
			// },
			// { page: this.privacyPage, url: '/privacy-policy' },
			// { page: this.refundPage, url: '/refund-policy' },
			// { page: this.offerPage, url: '/user-agreement' },
		];

		this.pageLength = this.mainDiv.getBoundingClientRect().height;
		this.isCreated = true;

		// Components
		this.footer = new Footer();
		this.footer.create();

		// this.cookieBanner = new CookieBanner();
		// this.cookieBanner.on('analytics:initialize', () => {
		// 	console.log('analytics:initialize');

		// 	const cookieAllowed = localStorage.getItem('cookieAllowed');
		// 	window.cookiedAllowed = cookieAllowed === 'true';
		// phc_E3bwXEmBdCFRjKA7eGcGOOq6BUIUo7n7SW8PaG9stLT
		this.cookieBanner = new CookieBanner();
		this.cookieBanner.on('analytics:initialize', () => {
			posthog.init(FN_URL.posthogKey, {
				api_host: 'https://eu.i.posthog.com',
				person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
				// debug: true,
			});
			posthog.set_config({
				persistence: 'localStorage+cookie', // 'memory' when not allowed?
			});
		});

		this.cookieBanner.on('analytics:reject', () =>
			console.log('analytics:reject')
		);
	}

	registerNodeEvents() {
		// this.tl = GSAP.timeline({
		// 	duration: 0.7,
		// 	ease: 'power4.out',
		// 	paused: true,
		// 	delay: 0.5,
		// });
		// this.tl.fromTo(
		// 	this.mainDiv,
		// 	{ y: -68 },
		// 	{ y: 0, duration: 1, ease: 'power4.out' }
		// );
		this.avery.$on('openMenu', () => {
			this.navigation.openMenu();
		});

		this.avery.$on('closeMenu', () => {
			this.navigation.closeMenu();
		});

		this.avery.$on('showLangPopup', () => {
			this.langPopup.show();
		});
		this.avery.$on('showMenu', () => {
			// this.tl.play();
			this.navigation.show();
		});
		this.avery.$on('hideMenu', () => {
			// this.tl.reverse();
			this.navigation.hide();
		});

		this.avery.$on('stopScroll', () => this.scroll.stop());
		this.avery.$on('startScroll', () => this.scroll.start());
	}

	update(time) {
		if (this.scroll) {
			this.scroll.raf(time);
			// this.scroll.on('scroll', ScrollTrigger.update);
		}

		this.frame = window.requestAnimationFrame(this.update.bind(this));
	}

	addEventListeners() {
		window.addEventListener('resize', debounce(this.onResize.bind(this))); // runs on the next
	}

	onResize() {
		this.avery.loader.current.page.onResize();
		if (this.footer) {
			this.footer.onResize();
		}
	}

	getCurrentLocale() {
		const currentPath = window.location.pathname;
		const normalizeUrl = (url) => {
			return url.endsWith('/') ? url.slice(0, -1) : url;
		};
		// Create a regex pattern from the LOCALES array
		const localePattern =
			LOCALES && LOCALES.length > 0
				? LOCALES.map((locale) => locale.code).join('|')
				: [];
		const regex = new RegExp(`^/(${localePattern})(/.*)?$`);

		// Extract locale and path
		const extractLocaleAndPath = (url) => {
			const match = url.match(regex);
			return match
				? { locale: match[1], path: normalizeUrl(match[2] || '/') }
				: { locale: '', path: normalizeUrl(url) };
		};

		let current = extractLocaleAndPath(currentPath);
		if (!current.locale) {
			current.locale = 'en'; // Default locale
		}

		console.log('👽', current);
		window.locale = current.locale;
	}
}

new App();
